import { WizardStep } from '@factorialco/deprecated-design-system'

import {
  A3INNUVA_INTEGRATION_ID,
  DATEV_LAUDS_INTEGRATION_ID,
} from 'modules/marketplace/lib/integrationIds'
import { useA3InnuvaSteps } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/Steps'
import { A3InnuvaWizardData } from 'modules/payroll_integrations_a3innuva/lib/types'
import { useDatevLaudsSteps } from 'modules/payroll_integrations_datev_lauds/components/SettingsSteps/Steps'
import { DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

export const useSettingsSteps = (integrationId: string) => {
  const settingsMap = new Map<
    string,
    (() => WizardStep<A3InnuvaWizardData>)[] | (() => WizardStep<DatevWizardData>)[]
  >([
    [A3INNUVA_INTEGRATION_ID, useA3InnuvaSteps()],
    [DATEV_LAUDS_INTEGRATION_ID, useDatevLaudsSteps()],
  ])

  return (settingsMap.get(integrationId) || []).map((component) => component())
}
